import { forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { Tooltip } from '@clds/tooltip';
import { isNoCustomers } from '@cld/session-service';
import { useUserData } from '../../context';
import { messages } from '../../i18n';
import { DefaultTriggerButton, DefaultTriggerButtonProps } from '../DefaultTriggerButton/DefaultTriggerButton';
import { useWorkspaceMenuData } from './useWorkspaceMenuData';
import { ProductEnvironmentAvatar } from '../ProductEnvironmentAvatar/ProductEnvironmentAvatar';
import styled from 'styled-components';

const RightSlot = styled.div`
  flex: 1;
  margin: auto 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const CurrentCustomerContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const DefaultWorkspaceTrigger = forwardRef<HTMLButtonElement, Partial<DefaultTriggerButtonProps>>((props, ref) => {
  const { formatMessage } = useIntl();
  const { currentCustomer, isSingleWorkspace } = useWorkspaceMenuData();
  const { userData } = useUserData();
  const noCustomers = isNoCustomers(currentCustomer);

  const displayedText = noCustomers ? (
    formatMessage(messages.noEnvironmentYet)
  ) : (
    <CurrentCustomerContainer>
      {currentCustomer?.displayName && (
        <div>
          <ProductEnvironmentAvatar productEnvironment={currentCustomer?.displayName}></ProductEnvironmentAvatar>
        </div>
      )}
      <RightSlot>{currentCustomer?.displayName}</RightSlot>
    </CurrentCustomerContainer>
  );

  return (
    <Tooltip placement="top" title={displayedText}>
      <DefaultTriggerButton
        {...props}
        disabled={noCustomers}
        ref={ref}
        analyticsMessage="product environment menu"
        isSingle={userData?.isMasterAdmin ? noCustomers : isSingleWorkspace}
        selected
      >
        <Tooltip.OverflowTrigger>{displayedText}</Tooltip.OverflowTrigger>
      </DefaultTriggerButton>
    </Tooltip>
  );
});
